import { Box, Stack, TextField } from "@mui/material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AutoCompleteList from "components/AutoCompleteList";
import moment from "moment";
import StockHistoryTable from "pages/inventory/history_template/StockHistoryTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { dispatch } from "store";
import { getDistributorThunk } from "store/reducers/accounts";
import { getDistributorStockHistoryThunk } from "store/reducers/inventory/stock/distributorStockSlice";

const DistributorStockHistory = () => {
  const [searchParams] = useSearchParams();
  const time = searchParams.get("time");
  const distributor = searchParams.get("distributor");
  const [filter, setFilter] = useState({
    time: time ? moment(time).add(1, "second") : moment(),
    distributor: null,
  });

  useEffect(() => {
    dispatch(
      getDistributorStockHistoryThunk({
        time: filter.time?.toISOString(),
        distributor: filter.distributor?.profile?.id ?? "" ,
      })
    );
  }, [filter.distributor, filter.time]);
  const state = useSelector((state) => state.distributorStock);

  useEffect(() => {
    dispatch(getDistributorThunk());
  }, []);
  const distributors = useSelector((state) => state.accounts.distributors);

  useEffect(() => {
    if (distributor && distributors) {
      const dist = distributors.find((item) => item.id ===  parseInt(distributor));
    //   console.log(dist)
      if(dist){
        setFilter((state) => ({ ...state, distributor: dist }));
      }
      
    }
  }, [distributor, distributors]);
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5} marginY={2}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="Pick a date"
            value={filter.time}
            onChange={(value) => setFilter({ ...filter, time: value })}
            renderInput={(params) => (
              <TextField variant="outlined" fullWidth {...params} />
            )}
          />
        </LocalizationProvider>

        <AutoCompleteList
          items={distributors}
          name="username"
          label="Filter distributer"
          setValue={(value) => ({ ...filter, distributor: filter.distributor })}
          value={filter.distributor}
        />
      </Stack>
      <StockHistoryTable items={state.history} />
    </Box>
  );
};

export default DistributorStockHistory;
